/**
 * Accordion
 */

//Add Inactive Class To All Accordion Headers
/*$(".accordion-header").toggleClass("inactive-header");

//Set The Accordion Content Width
var contentwidth = $(".accordion-header").width();
$(".accordion-content").css({ width: contentwidth });

//Open The First Accordion Section When Page Loads
// $('.accordion-header').first().toggleClass('active-header').toggleClass('inactive-header');
// $('.accordion-content').first().slideDown().toggleClass('open-content');

// The Accordion Effect
$(".accordion-header").click(function () {
	if ($(this).is(".inactive-header")) {
		$(".active-header")
			.toggleClass("active-header")
			.toggleClass("inactive-header")
			.next()
			.slideToggle()
			.toggleClass("open-content");
		$(this).toggleClass("active-header").toggleClass("inactive-header");
		$(this).next().slideToggle().toggleClass("open-content");
	} else {
		$(this).toggleClass("active-header").toggleClass("inactive-header");
		$(this).next().slideToggle().toggleClass("open-content");
	}
});*/
// Product info accordion
$(".accordion-header").click(function () {
  $(this).toggleClass("active-header").next().slideToggle();  
});
// Custom popup

$(document).ready(function () {
	$(".popup-trigger").on("click", function () {
		var id = $(this).data("id");

		$("#" + id).show();
	});

	$(".popup-close").on("click", function () {
		var id = $(this).data("id");

		$("#" + id).hide();
	});
});

$(".fancybox").fancybox();

var width = $(".gallery__image-container").width();
$(".gallery__image-container").each(function () {
	$(this).height(width);
});

//Auto Scroll
$(document).on('click', '.rte a[href^="#"].scroll', function (event) {
  // event.preventDefault();

  console.log($($.attr(this, 'href')));

  $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top - 200
  }, 500);
});

/**
 * FAQ PAGE START
 */

function searchFunction() {
  var input, filter, ul, li, s, p, i, txtValue;
  input = document.getElementById('myInput');
  filter = input.value.toUpperCase();
  ul = document.getElementById("myUL");
  li = ul.getElementsByTagName('li');

  // Loop through all list items, and hide those who don't match the search query
  for (i = 0; i < li.length; i++) {
    p = li[i].getElementsByTagName("p")[0];
    s = li[i].querySelectorAll(".accordion-thumb")[0];
    txtValue = (s.textContent || s.innerText) + " " + (p.textContent || p.innerText) ;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      li[i].style.display = "";
    } else {
      li[i].style.display = "none";
    }
  }
}

filterSelection("all")
function filterSelection(c) {
  var x, i;
  x = document.getElementsByClassName("filterDiv");
  if (c == "all") c = "";
  // Add the "show" class (display:block) to the filtered elements, and remove the "show" class from the elements that are not selected
  for (i = 0; i < x.length; i++) {
    faqRemoveClass(x[i], "show");
    if (x[i].className.indexOf(c) > -1) faqAddClass(x[i], "show");
  }
}

// Show filtered elements
function faqAddClass(element, name) {
  var i, arr1, arr2;
  arr1 = element.className.split(" ");
  arr2 = name.split(" ");
  for (i = 0; i < arr2.length; i++) {
    if (arr1.indexOf(arr2[i]) == -1) {
      element.className += " " + arr2[i];
    }
  }
}

// Hide elements that are not selected
function faqRemoveClass(element, name) {
  var i, arr1, arr2;
  arr1 = element.className.split(" ");
  arr2 = name.split(" ");
  for (i = 0; i < arr2.length; i++) {
    while (arr1.indexOf(arr2[i]) > -1) {
      arr1.splice(arr1.indexOf(arr2[i]), 1); 
    }
  }
  element.className = arr1.join(" ");
}

// Add active class to the current control button (highlight it)
addActiveClass();
function addActiveClass(){
  var btnContainer = document.getElementById("myBtnContainer");
  if ( !btnContainer ){
    return;
  }
  var btns = btnContainer.getElementsByClassName("btn");
  for (var i = 0; i < btns.length; i++) {
    btns[i].addEventListener("click", function() {
      var current = document.getElementsByClassName("active");
      current[0].className = current[0].className.replace(" active", "");
      this.className += " active";
    });
  }
}


 
// Accordion Function
$(function() {
	// (Optional) Active an item if it has the class "is-active"	
	$("#myUL > .filterDiv.is-active").children(".accordion-panel").slideDown();
	
	$("#myUL > .filterDiv > .accordion-thumb").click(function() {
    //event.preventDefault();
		// Cancel the siblings
		$(this).closest('li').siblings(".filterDiv").removeClass("is-active").children(".accordion-panel").slideUp();
		// Toggle the item
		$(this).closest('li').toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
	});
});

/**
 * FAQ PAGE END
 */

/**
 * Checkout page agree terms and services
 */
 $(document).ready(function() {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("You must agree with the terms and conditions of sales to check out.");
      return false;
    }
  });
});